import ReactDOM from 'react-dom';
import './index.css';
import App from './App';

declare global {
  interface Window {
    QB: QB;
    QBVideoConferencingClient: QBVideoConferencingClient;
  }
  export const __DEV__: boolean;
  export const JANUS_URL_EU: string;
  export const JANUS_URL_US: string;
}

ReactDOM.render(<App />, document.getElementById('app-root'));
